/**
 * installmentsDrawer — Alpine.js component
 *
 * Controls the Installments drawer that slides in from the right.
 * Responds to the 'installments:toggle' window event dispatched by
 * the runInstallmentsToggle action (arc:action:installmentsToggle).
 *
 * Trigger from a button-link block:
 *   Action Preset: Custom
 *   Custom Event IDs: installmentsToggle
 */

export default {
  name: 'installmentsDrawer',
  component() {
    return {
      isOpen: false,
      activeTab: 0,

      init() {
        this._toggleHandler = () => this.toggle();
        this._openHandler   = () => this.open();
        this._closeHandler  = () => this.close();

        window.addEventListener('installments:toggle', this._toggleHandler);
        window.addEventListener('installments:open',   this._openHandler);
        window.addEventListener('installments:close',  this._closeHandler);

        this._keyHandler = (e) => {
          if (e.key === 'Escape' && this.isOpen) this.close();
        };
        document.addEventListener('keydown', this._keyHandler);
      },

      destroy() {
        window.removeEventListener('installments:toggle', this._toggleHandler);
        window.removeEventListener('installments:open',   this._openHandler);
        window.removeEventListener('installments:close',  this._closeHandler);
        document.removeEventListener('keydown', this._keyHandler);
        document.body.classList.remove('no-scroll');
      },

      open() {
        this.isOpen = true;
      },

      close() {
        this.isOpen = false;
      },

      toggle() {
        this.isOpen ? this.close() : this.open();
      },
    };
  },
};
